import PropTypes from "prop-types";
import { StyledError } from "../../styles/StyledError";

export default function Error({ children }) {
	return <StyledError data-testid="error">{children}</StyledError>;
}

Error.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
};
